import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import Sidebar from '../components/sidebar'
import Footer from '../components/footer'
import Head from '../components/head'
import { imgSrc, Stars } from './form';

export default function Main() {
  const [reviews, setReviews] = useState([])
  const [delItem, setDelItem] = useState(null)
  const [deleting, setDeleting] = useState(false)

  useEffect(() => {
    getAllReviews();
  }, []);

  const getAllReviews = async () => {
    axios({
      method: 'post',
      url: '/api/review/list.php',
    })
      .then(s => {
        setReviews(s.data)
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  const deleteReview = async () => {
    const id = delItem.id
    setDeleting(true)
    const data = new FormData();
    data.append('id', id);
    axios({
      method: 'post',
      url: '/api/review/delete.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        if (s.data[0].msg === "pass") {
          setReviews(reviews.filter((v) => v.id !== id))
        } else {
          alert("Delete nahi hua, dobara koshish karein.")
        }
      })
      .catch(s => {
        console.log('here catch =>>', s);
        alert("Delete nahi hua, dobara koshish karein.")
      })
      .finally(() => {
        setDeleting(false)
        setDelItem(null)
      });
  };

  return (
    <>
      <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
          <Head />
          <div>
            <div className="page-content">
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-header bg-gradient-primary text-white py-4">
                      <div className="d-flex align-items-center">
                        <div>
                          <h4 className="mb-1">Review List</h4>
                          <span className="opacity-75">Website ke tamam customer reviews manage karein</span>
                        </div>
                        <a href="addreview" className="btn btn-light btn-sm ms-auto me-2">+ New Review</a>
                        <span className="badge bg-light text-dark py-2 px-3">{reviews.length} Entries</span>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Sort</th>
                              <th>Image</th>
                              <th>Name</th>
                              <th>Rating</th>
                              <th>Description</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              reviews.map((v) => (
                                <tr key={v.id}>
                                  <td>{v.sort}</td>
                                  <td>
                                    {v.img
                                      ? <img src={imgSrc(v.img)} alt={v.name}
                                          style={{ width: '44px', height: '44px', borderRadius: '50%', objectFit: 'cover' }} />
                                      : <span className="text-muted">—</span>}
                                  </td>
                                  <td>{v.name}</td>
                                  <td><Stars value={v.rating} size="1rem" /></td>
                                  <td className="text-truncate" style={{ maxWidth: '400px' }} title={v.review}>{v.review}</td>
                                  <td>
                                    {String(v.status) === "1"
                                      ? <span className="badge bg-success">Active</span>
                                      : <span className="badge bg-secondary">Inactive</span>}
                                  </td>
                                  <td>
                                    <a href={"updatereview?id=" + v.id}>
                                      <button className="btn btn-primary btn-sm me-2">Edit</button>
                                    </a>
                                    <button className="btn btn-danger btn-sm" onClick={() => setDelItem(v)}>Delete</button>
                                  </td>
                                </tr>
                              ))
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>

      {/* Delete confirmation popup */}
      {delItem && (
        <div
          onClick={() => !deleting && setDelItem(null)}
          style={{
            position: 'fixed', inset: 0, zIndex: 1050,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '16px'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: '8px', width: '100%', maxWidth: '440px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.2)', overflow: 'hidden'
            }}
          >
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #e9ecef' }}>
              <h5 className="mb-0" style={{ color: '#dc3545' }}>Delete Review?</h5>
            </div>
            <div style={{ padding: '20px 24px' }}>
              <p className="mb-2">Kya aap <b>{delItem.name}</b> ka review delete karna chahte hain?</p>
              <small className="text-muted">Delete hone ke baad yeh wapas nahi aa sakta.</small>
            </div>
            <div className="d-flex justify-content-end" style={{ padding: '16px 24px', borderTop: '1px solid #e9ecef', gap: '8px' }}>
              <button className="btn btn-light" disabled={deleting} onClick={() => setDelItem(null)}>Cancel</button>
              <button className="btn btn-danger" disabled={deleting} onClick={deleteReview}>
                {deleting ? 'Deleting...' : 'Yes, Delete'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
